export enum Basketball3x3FoulAttribute {
  Offensive = 705,
  Technical = 706,
  Unsportsmanlike = 707,
}
